/**
 * エディタのシンタックスハイライト定義。
 *
 * **下線を一切使わない**（ADR-025）。IME の未確定文字列は下線で表示されるため、
 * 装飾側でも下線を使うと「変換中かどうか」が読み取れなくなる。編集面において
 * 下線は IME に予約された表現とみなす。CM6 の `defaultHighlightStyle` は
 * 見出しとリンクに `text-decoration: underline` を当てるので、そのまま使えない。
 *
 * 色はデザインシステムのトークン（design-system/、`var(--al-*)`）を参照する。
 * ここに生の色を書かないのは、配色が DS 側で変わったときに追従させるため。
 */

import { HighlightStyle } from '@codemirror/language';
import { tags as t } from '@lezer/highlight';

export const markdownHighlightStyle = HighlightStyle.define([
  // 見出し: 下線ではなく太さと大きさで示す。
  // 太さは 600 まで（DESIGN-SYSTEM.md §4「700 以上は原則使用しない」）。大きさで差を付ける。
  { tag: t.heading, color: 'var(--al-color-rose-text)', fontWeight: '600' },
  { tag: t.heading1, color: 'var(--al-color-rose)', fontWeight: '600' },

  { tag: t.strong, fontWeight: '600' },
  { tag: t.emphasis, fontStyle: 'italic' },
  { tag: t.strikethrough, textDecoration: 'line-through' },

  // リンク: 下線ではなく色で示す。
  { tag: t.link, color: 'var(--al-color-primary-hover)' },
  { tag: t.url, color: 'var(--al-color-primary-hover)' },

  { tag: t.monospace, fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' },

  // 記法そのもの（`#`, `-`, `>`, ``` など）は控えめに。本文の可読性を優先する。
  { tag: t.processingInstruction, color: 'var(--al-color-text-tertiary)' },
  { tag: t.comment, color: 'var(--al-color-text-tertiary)', fontStyle: 'italic' },
]);
